import axios from './axios';

/**
 * Get public settings (deposit percentage, contact info)
 */
export const getPublicSettings = async () => {
    const response = await axios.get('/settings/public');
    return response.data;
};

/**
 * Get deposit percentage only
 */
export const getDepositPercentage = async () => {
    const response = await axios.get('/settings/deposit-percentage');
    return response.data;
};

/**
 * Get all settings (admin only)
 */
export const getAllSettings = async () => {
    const response = await axios.get('/admin/settings');
    return response.data;
};

/**
 * Update a setting (admin only)
 */
export const updateSetting = async (key, value) => {
    const response = await axios.put(`/admin/settings/${key}`, { value });
    return response.data;
};

/**
 * Upload hero images (admin only)
 */
export const uploadHeroImages = async (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('images[]', file));
    const response = await axios.post('/admin/settings/hero-images', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 60000,
    });
    return response.data;
};

/**
 * Delete a hero image (admin only)
 */
export const deleteHeroImage = async (imageUrl) => {
    const response = await axios.delete('/admin/settings/hero-images', {
        data: { image_url: imageUrl },
    });
    return response.data;
};

export default {
    getPublicSettings,
    getDepositPercentage,
    getAllSettings,
    updateSetting,
    uploadHeroImages,
    deleteHeroImage,
};
